var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSyselfinline = function SvgSyselfinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206116,
    height: 27889,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#syself_inline_svg__a)",
    d: "M6.553 8.518a10.39 8.07 0 0 0-5.162 7.105 9.148 7.105 0 0 0 .98 3.502c.556.99 1.634 1.853 3.137 2.462 1.372.634 3.365 1.268 5.848 1.674a11.696 9.084 0 0 1 4.443 1.447c.882.507 1.34 1.116 1.307 1.954 0 .964-.523 1.674-1.438 2.131-.98.584-2.188.787-4.05.761-3.268.051-6.175-.837-8.887-2.588L.9 31.026c1.21.99 2.712 1.726 4.705 2.259 1.862.507 3.855.685 6.011.71 3.561.076 6.371-.71 8.43-2.106 2.058-1.421 3.038-3.299 2.94-5.735.098-2.03-.784-3.603-2.287-4.72a17.152 13.322 0 0 0-7.645-2.918 22.543 17.509 0 0 1-3.529-.761c-.784-.406-1.372-.761-1.83-1.142a2.94 2.284 0 0 1-.424-1.446c0-.965.36-1.777 1.307-2.386a5.554 4.314 0 0 1 3.757-.76c2.94-.052 5.554.837 8.102 2.537l1.83-4.06a14.375 11.165 0 0 0-9.965-2.944 11.598 9.008 0 0 0-5.75.964z",
    style: {
      fill: "url(#syself_inline_svg__a)",
      strokeWidth: 0.287928
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#syself_inline_svg__b)",
    d: "m46.216 15.319-5.162 11.926-5.032-11.977H29.88l8.103 17.458-.49 1.193c-.49 1.066-1.307 1.903-2.255 2.487a14.081 10.937 0 0 1-4.05 1.37l1.404 4.11a13.395 10.404 0 0 0 6.24-2.03 17.61 13.677 0 0 0 4.215-5.227l8.951-19.285h-5.782z",
    style: {
      fill: "url(#syself_inline_svg__b)",
      strokeWidth: 0.287928
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#syself_inline_svg__c)",
    d: "M62.878.601c-2.94 0-5.424 1.929-5.424 4.263v33.75a5.554 4.314 0 0 0 5.424 4.313h80.827a5.554 4.314 0 0 0 5.423-4.314V4.864c0-2.334-2.482-4.263-5.423-4.263zm67.17 16.037h3.595v-1.141c0-2.284.555-4.137 1.83-5.43 1.175-1.27 2.94-1.904 5.226-1.904 1.373 0 2.385.203 3.202.508v4.263a8.395 8.395 0 0 0-1.83-.229c-.816 0-1.568.229-2.025.635-.555.507-.817 1.268-.817 2.283v1.015h3.92v4.111h-3.92v14.312h-5.586V20.749h-3.594zm-14.374-8.272h5.684v26.695h-5.684zM90.746 32.802a13.722 10.658 0 0 1-2.744-6.978c0-1.852.326-3.552 1.176-4.999a9.082 7.054 0 0 1 3.3-3.425c1.372-.762 3.038-1.193 4.77-1.193a7.514 5.836 0 0 1 6.337 2.487 14.963 11.622 0 0 1 2.385 6.851v.761H93.392a9.475 7.359 0 0 0 1.372 3.781c.817.762 2.124 1.142 3.66 1.142a6.534 5.075 0 0 0 2.94-.507c1.013-.28 1.96-.71 2.744-1.345l1.47 3.705c-.914.71-1.993 1.268-3.365 1.624a10.128 7.866 0 0 1-3.953.66 9.148 7.105 0 0 1-7.514-2.564zM73.43 31.026a1.862 1.446 0 0 0 .817-1.294c0-.431-.196-.761-.555-1.066-.36-.279-1.111-.507-2.026-.71l-3.104-.635c-1.731-.431-3.136-1.015-3.92-1.852a6.665 5.177 0 0 1-1.405-3.426c0-1.142.36-2.131 1.11-2.994.654-.939 1.634-1.65 2.843-2.131 1.176-.508 2.647-.71 4.215-.71 1.372 0 2.646.202 3.92.557a14.172 14.172 0 0 1 3.496 1.7l-1.568 3.654a13.395 10.404 0 0 0-2.94-1.522c-1.079-.254-1.993-.482-2.94-.482-.981 0-1.634.203-2.19.507a1.862 1.446 0 0 0-.817 1.27 1.96 1.523 0 0 0 .458 1.014c.36.254.915.508 1.764.635l3.104.71a7.841 6.09 0 0 1 4.214 1.929c.915.913 1.307 2.055 1.307 3.476 0 1.776-.653 3.146-2.124 4.136-1.47 1.015-3.397 1.573-5.978 1.573a11.761 9.135 0 0 1-8.43-2.283l1.504-3.807a10.553 8.196 0 0 0 7.056 2.132c.915 0 1.732-.127 2.222-.432zm21.432-10.048c-.718.558-1.11 1.42-1.306 2.639h7.514c-.327-2.436-1.536-3.553-3.627-3.553a3.006 2.335 0 0 0-2.58.914z",
    style: {
      fill: "url(#syself_inline_svg__c)",
      strokeWidth: 0.287928
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "syself_inline_svg__a",
    x1: -22.4,
    x2: 450.7,
    y1: 78,
    y2: 89.7,
    gradientTransform: "matrix(.3267 0 0 .25375 .803 .601)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D48744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "syself_inline_svg__b",
    x1: -23.1,
    x2: 450,
    y1: 106.7,
    y2: 118.3,
    gradientTransform: "matrix(.3267 0 0 .25375 .803 .601)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D48744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "syself_inline_svg__c",
    x1: 173.4,
    x2: 454,
    y1: 83.4,
    y2: 83.4,
    gradientTransform: "matrix(.3267 0 0 .25375 .803 .601)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E37894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D48744"
  })))));
};
export default SvgSyselfinline;